import {Dispatch} from 'redux';
import {EnhancedErrorHandler} from '../types';
import {createAggregateErrorHandler} from './createAggregateErrorHandler';
import {onAuthErrorLogout} from './onAuthErrorLogout';
import {onApiErrorShowSnack} from './onApiErrorShowSnack';

export const getAggregateErrorHandler = (
  errorHandler: EnhancedErrorHandler | undefined,
  dispatch: Dispatch,
) =>
  createAggregateErrorHandler(
    dispatch,
    onAuthErrorLogout,
    errorHandler,
    onApiErrorShowSnack,
  );
